import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import "../Styles-css/Home.css";
import { FaPhoneAlt } from "react-icons/fa";

import img1 from "../Image/home-img01.jpg";
import img2 from "../Image/home-img02.png";

import test1 from "../Image/testimonial-1.jpg";
import test2 from "../Image/testimonial-2.jpg";
import test3 from "../Image/testimonial-3.jpg";

import cart1 from "../Image/house1.jpg";
import cart2 from "../Image/villa.jpg";
import cart3 from "../Image/16.jpg";
import cart4 from "../Image/11.jpg";

import m6 from "../Image/m6.jpg"
import m2 from "../Image/m2.jpg"
import m3 from "../Image/m3.jpg"
import m4 from "../Image/m4.jpg"
import m5 from "../Image/m5.jpg"


const properties = [
  { id: 1, name: "Appartment", count: 6, icon: "🏢", highlight: true },
  { id: 2, name: "Commercial", count: 6, icon: "🏬", highlight: true },
  { id: 3, name: "Solo Shop", count: 6, icon: "🛍️", highlight: true },
  { id: 4, name: "Town Ship", count: 3, icon: "🏘️", highlight: true },
  { id: 5, name: "Villa", count: 3, icon: "🏠", highlight: true },
  { id: 6, name: "Warehouse", count: 3, icon: "🏭", highlight: true },
];

const Properties_card = [
  {
    id: 1,
    image: cart1, 
    price: "For Rent",
    name: "Spacious Family Homes",
    location:"Explore our collection of well-maintained houses ideal for families and individuals. From cozy single-family homes to large multi-bedroom residences, we offer flexible rental options in peaceful neighborhoods. ",
    category: "For Sale",
    tag: "House",
  },
  {
    id: 2,
    image: cart2,
    price: "For Rent",
    name: "Elegant Luxury Villas",
    location:"Immerse yourself in luxurious living with our premium villas. Surrounded by lush gardens and tranquil views, these villas are perfect for upscale living, vacation homes, or family retreats, offering the ultimate blend of style and comfort.",
    category: "For Sale",
    tag: "Villa",
  },
  {
    id: 3,
    image: cart3,
    price: "For Rent",
    name: "High-Capacity Warehouses",
    location:"Our secure, scalable warehouses are ideal for businesses requiring efficient storage solutions. With 24/7 security and flexible layouts, these spaces cater to logistics, inventory management, and industrial use.",
    category: "For Lease",
    tag: "Warehouse",
  },
  {
    id: 4,
    image: cart4,
    price: "For Rent",
    name: "Modern City Apartments",
    location:"Live the urban lifestyle with our sleek, modern apartments. Designed with spacious layouts and top-tier amenities, these homes offer easy access to schools, shopping, and transport—perfect for professionals, families, and students.",
    category: "For Rent",
    tag: "Apartment",
  },
];
const categories = ["All Properties", "For Sale", "For Lease", "For Rent"];

const localities = [
  {
    title: 'Ashoka Garden',
    properties: '651+ Properties',
    image: m6,
  },
  {
    title: 'Saket Nagar',
    properties: '413+ Properties',
    image: m2,  
},
  {
    title: 'Indrapuri',
    properties: '177+ Properties',
    image: m3,
  },
  {
    title: 'Kolar',
    properties: '285+ Properties',
    image: m4,
  },
  {
    title: 'MP Nagar',
    properties: '519+ Properties',
    image: m5,
  },
];

const testimonials = [
  {
    name: "Balasubramanyam K.c.",
    text: `"Kiraya Wala, I really would like to appreciate positive and quick responses from you guys. Thank you for excellent service through paid plans of kirayawala.in."`,
    rating: 5,
    title: "Appreciate Positive and quick responses from RM",
  },
  {
    name: "Tiasha",
    text: `"The service was great and very professional. I went with the Relax plan."`,
    rating: 5,
    title: "Best Option",
  },
  {
    name: "Anoop Nair",
    text: `"Excellent service and an equally involved team. I opted for the Relax plan and got a good deal on my property. Highly recommended app"`,
    rating: 5,
    title: "Excellent Service",
  },
  {
    name: "Avni Sharma",
    text: `"Kiraya wala, I really would like to appreciate positive and quick responses from you guys. Thank you for excellent service through paid plans of kirayawala.in"`,
    rating: 4,
    title: "Appreciate Positive and quick responses from RM",
  },
  {
    name: "Rahul",
    text: `"Timely updates and fast response. The RM was always in touch and ensured I got the best options."`,
    rating: 4,
    title: "Prompt Response",
  },
  {
    name: "Neha",
    text: `"Very cooperative team. Smooth process from beginning to end. Highly satisfied!"`,
    rating: 5,
    title: "Smooth Process",
  }
];
const Home = () => {
  // ------------------localities start-------------------
        const [scrollX, setScrollX] = useState(0);

        const scrollLeft = () => {
          setScrollX(scrollX - 300);
        };

        const scrollRight = () => {
          setScrollX(scrollX + 300);
        };
  // ------------------localities End -------------------
  // ------------------testimination start -------------------

        const [startIndex, setStartIndex] = useState(0);
            const cardsPerView = 3;

            const prev = () => {
              setStartIndex((prevIndex) =>
                prevIndex - cardsPerView < 0
                  ? testimonials.length - cardsPerView
                  : prevIndex - cardsPerView
              );
            };

            const next = () => {
              setStartIndex((prevIndex) =>
                prevIndex + cardsPerView >= testimonials.length
                  ? 0
                  : prevIndex + cardsPerView
              );
            };

            const visibleCards = testimonials.slice(startIndex, startIndex + cardsPerView);
  // ------------------testimination End -------------------

  // ------------------Slider Start -------------------

      const [slides, setSlides] = useState([]);

      useEffect(() => {
        const fetchSlides = async () => {
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_BASE_URL}/sliders`
            );
            setSlides(response.data);
          } catch (error) {
            console.error("Error loading sliders:", error);
          }
        };

        fetchSlides();
      }, []);
    // ------------------Slider End -------------------

  const [selectedCategory, setSelectedCategory] = useState("All Properties");

  const filteredProperties =
    selectedCategory === "All Properties"
      ? properties
      : properties.filter((property) => property.category === selectedCategory);

  return (
    <>
      {/*----- -------------------------- Hero Section Start ----------------------------------------------- */}
      <div className="container">
        <div className="home-slider-container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 }}
            loop={slides.length > 2}
            effect="fade"
            className="home-swiper"
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div
                  className="slide"
                  style={{
                    backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/slider/${slide.imageUrl})`,
                  }}
                >
                  <div className="overlay">
                    <div className="slide-content">
                      <h2 className="slide-title">{slide.title}</h2>
                      <p className="slide-subtitle">{slide.description}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/*----- -------------------------- Hero Section End ----------------------------------------------- */}
        {/*----- -------------------------- Property Catagory Start ----------------------------------------------- */}

        <div className="property-section">
          <h4 className="newly-listed">NEWLY LISTED</h4>
          <h2 className="heading">Search By Property Requirement</h2>
          <div className="property-container">
            {properties.map((property) => (
              <div
                key={property.id}
                className={`property-card ${
                  property.highlight ? "highlighted" : ""
                }`}
              >
                <div className="pro-icon">{property.icon}</div>
                <h3>{property.name}</h3>
                <p>{property.count} Properties</p>
                {property.highlight && (
                  <span className="view-details">View Details</span>
                )}
              </div>
            ))}
          </div>
        </div>
        {/*----- -------------------------- Property Catagory End----------------------------------------------- */}

        {/*----- -------------------------- Hero Section Start----------------------------------------------- */}
        <div className="hero-section">
          <div className="hero-images">
            <img src={img1} alt="Luxury House" className="house-img" />
            <img src={img2} alt="Modern Villa" className="villa-img" />
            <div className="ratings">
              <div className="rating-users">
                <img src={test1} alt="User" />
                <img src={test2} alt="User" />
                <img src={test3} alt="User" />
                <span className="more-users">69+</span>
              </div>
              <p>Top Rated around globe</p>
            </div>
          </div>

          <div className="hero-content">
            <h4 className="sub-heading">WORLDWIDE PROPERTIES</h4>
            <h2 className="main-heading">
              <span className="heading-name">Kiraya Wala</span> is your trusted partner in the world of property rentals.
            </h2>
            <p className="hero-description">
              KirayaWala is India's leading home rental and property management platform, revolutionizing the way people find, rent, buy, or sell homes through innovative design and technology.
              For buyers, we simplify the process by helping you find the right home, handling negotiations, and ensuring hassle-free registration. For tenants, our services go beyond just finding a home. We provide move-in support, expert home maintenance services like cleaning and repairs, online rent payment option, and stress-free move-out assistance.              
            </p>

           <div className="features">
            <div className="instruction-container">
              <ul className="instruction-list">
                <li>Unmatched Privacy</li>
                <li>Instant Move-In</li>
                <li>Lowest Security Deposit</li>
                <li>kirayawala Network</li>
              </ul>
            </div>
          </div>
          <div className="buttons">
              <button className="explore-btn">Explore Properties</button>
              <div className="home-call-btn">
                <FaPhoneAlt className="phone-icon" />
                <span>Call Now</span>
                <p>+91 7898622741</p>
              </div>
            </div>
          </div>
        </div>

        {/*----- -------------------------- property card start ----------------------------------------------- */}
        <div className="property-section">
          <h3 className="section-subtitle">EXPLORE VILLAS</h3>
          <h2 className="section-title">Comfort Living Solution</h2>

          <div className="property-filters">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${
                  selectedCategory === category ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="home-property-list">
            {Properties_card.map((property) => (
              <div className="home-property-card" key={property.id}>
                <img
                  src={property.image}
                  alt={property.name}
                  className="property-image"
                />
                <span className="property-price">{property.price}</span>
                {property.tag && (
                  <span className="property-tag">{property.tag}</span>
                )}
                <div className="property-info">
                  <h3 className="property-name">{property.name}</h3>
                  <p className="property-location">{property.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/*----- -------------------------- property card end ----------------------------------------------- */}
        {/*----- -------------------------- blog section start ----------------------------------------------- */}
        <div className="popular-container">
          <h4 className="popular-subtitle">In and around Bhopal</h4>
          <h2 className="popular-title">Popular Localities</h2>
          <div className="carousel-wrapper">
            <div className="card-container" style={{ transform: `translateX(-${scrollX}px)` }}>
              {localities.map((item, index) => (
                <div className="card" key={index}>
                  <img src={item.image} alt={item.title} />
                  <div className="card-info">
                    <h3>{item.title}</h3>
                    <p>{item.properties}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/*----- --------------------------blog section end ----------------------------------------------- */}
        {/*----- --------------------------testimination part ----------------------------------------------- */}
        <div className="testimination-container">
        <center><h2 className="home-main-heading">Testimination</h2></center>
        <div className="carousel-container">
              <button className="arrow left" onClick={prev}>&#8592;</button>
              <div className="testimonial-wrapper">
                {visibleCards.map((testimonial, i) => (
                  <div className="testimonial-card" key={i}>
                    <h3>{testimonial.name}</h3>
                    <div className="stars">{'★'.repeat(testimonial.rating)}</div>
                    <h4>{testimonial.title}</h4>
                    <p>{testimonial.text}</p>
                  </div>
                ))}
              </div>

              <button className="arrow right" onClick={next}>&#8594;</button>
            </div>
          </div>  
        
      </div>
    </>
  );
};

export default Home;
